import $c5j3y$react, {useContext as $c5j3y$useContext} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $561e3d9e91a7fb1c$export$b118023277d4a5c3 = (0, $c5j3y$react).createContext(null);
function $561e3d9e91a7fb1c$export$b054eba74077a826() {
    return (0, $c5j3y$useContext)($561e3d9e91a7fb1c$export$b118023277d4a5c3) || {};
}


export {$561e3d9e91a7fb1c$export$b118023277d4a5c3 as RadioContext, $561e3d9e91a7fb1c$export$b054eba74077a826 as useRadioProvider};
//# sourceMappingURL=context.mjs.map
